import * as React from 'react'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

type ReportItemDetailLabelProps = {
    label: string
    text?: string | number | null
    color?: string
    signalImg?: string
}

const ReportItemDetailLabel = (props: ReportItemDetailLabelProps) => {
    let text = '-'
    if (props.text) {
        text = props.text.toString()
    }

    return (
        <>
            <StyledTypoTitle>{props.label}</StyledTypoTitle>
            <StyledTypo style={{ color: props?.color }}>
                {
                    props.signalImg ? (
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <img src={props.signalImg} style={{ width: '25px' }} />
                            <div>{text}</div>
                        </Stack>
                    ) : (
                        <div>{text}</div>
                    )
                }
            </StyledTypo>
        </>
    )
}

const StyledTypoTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
}))

const StyledTypo = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.dark,
}))

export default ReportItemDetailLabel
